import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
export function Label({ className, children, ...rest }) {
    return (_jsx("label", { className: clsx("label", className), ...rest, children: children }));
}
//# sourceMappingURL=Label.js.map